import { SnapchatSettingsForm } from '@/routes/trackings/destinations/snapchat/snapchat-settings';
import { SnapchatProductSettingsTab } from '@/routes/trackings/destinations/snapchat/snapchat-product-settings';
import { TransactionsFilteringForm } from '@/routes/trackings/components/transactions-filtering-form';
import DownloadSnapchatGtmContainer from '@/routes/trackings/destinations/snapchat/snapchat-download-gtm';
import { useNavigate, useParams } from 'react-router-dom';
import {
  createSetupNavigator,
  DestinationTrackingDetails
} from '@/routes/trackings/components/destination-tracking-details';
import { useCallback, useMemo, useState } from 'react';

export const SnapchatTrackingDetails = ({
  isPublishable,
  isSetup
}: {
  isPublishable: boolean;
  isSetup: boolean;
}) => {
  const navigate = useNavigate();
  const { tab = 'integration', id } = useParams<{ tab: string; id: string }>();

  const [displayTabs, setDisplayTabs] = useState([
    {
      label: 'Snapchat Settings',
      value: 'integration',
      disabled: false,
      setupCompleted: false
    },
    {
      label: 'Product Settings',
      value: 'product-settings',
      disabled: true,
      setupCompleted: false
    },
    {
      label: 'Transactions',
      value: 'transactions',
      disabled: true,
      setupCompleted: false
    },
    {
      label: 'GTM Container',
      value: 'gtm-container',
      disabled: true,
      setupCompleted: false,
      isPublishable: isPublishable
    }
  ]);

  const [activeTab, setActiveTab] = useState(tab || displayTabs[0].value);

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      setActiveTab(newTabValue);
      void navigate(`../integrations/${id!}/${newTabValue}`, { replace: true, state: { isSetup } });
    },
    [navigate, id, isSetup, setActiveTab]
  );

  const navigateToNextStep = useMemo(
    () =>
      createSetupNavigator(
        () => displayTabs,
        () => activeTab,
        setDisplayTabs,
        handleTabChange
      ),
    [displayTabs, activeTab, handleTabChange, isPublishable]
  );

  const handleNonSetupContinue = useCallback(() => {
    // TODO: FIX LOGIC SO EMPTY FUNCTION IS NOT NEEDED
  }, []);

  const onContinue = isSetup ? navigateToNextStep : handleNonSetupContinue;

  const content = [
    {
      key: 'integration',
      content: <SnapchatSettingsForm onContinue={onContinue} />
    },
    {
      key: 'product-settings',
      content: <SnapchatProductSettingsTab isSetup={isSetup} onContinue={onContinue} />
    },
    {
      key: 'transactions',
      content: (
        <TransactionsFilteringForm isLastTab={false} onContinue={onContinue} isSetup={isSetup} />
      )
    },
    { key: 'gtm-container', content: <DownloadSnapchatGtmContainer /> }
  ];

  return (
    <DestinationTrackingDetails
      displayTabs={displayTabs}
      isSetup={isSetup}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      id={id!}
      content={content}
    />
  );
};
